(() => {
  function initHydroSealKitSelector() {
    const root = document.getElementById('hydro-inline-kit');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const productInfo = root.closest('product-info') || document;
    const nativeVariantPicker = root.closest('.rte')?.nextElementSibling;
    const modes = root.querySelectorAll('.hydro-mode');
    const views = root.querySelectorAll('.hydro-view');
    const cards = root.querySelectorAll('.hydro-card');
    const add = root.querySelector('.hydro-add');
    const buyNow = root.querySelector('.hydro-buy-now');
    const note = root.querySelector('.hydro-note');
    const mobileBar = root.parentElement?.querySelector('[data-hydro-mobile-bar]') || document.querySelector('[data-hydro-mobile-bar]');
    const mobileTitle = mobileBar?.querySelector('strong');
    const mobileMeta = mobileBar?.querySelector('span');
    const mobileButton = mobileBar?.querySelector('button');
    const galleryContainer = productInfo.closest('.product')?.querySelector('.product__gallery-container');
    const galleryTemplate = root.parentElement?.querySelector('[data-hydro-glass-gallery]');
    let glassGallery = galleryContainer?.querySelector('.hydro-kit-gallery');
    if (!glassGallery && galleryContainer && galleryTemplate) {
      glassGallery = galleryTemplate.content.firstElementChild.cloneNode(true);
      galleryContainer.prepend(glassGallery);
    }
    const glassImage = glassGallery?.querySelector('img');

    if (mobileBar && mobileBar.parentElement !== document.body) {
      document.querySelectorAll('body > [data-hydro-mobile-bar]').forEach((bar) => bar.remove());
      document.body.appendChild(mobileBar);
    }

    let currentMode = 'kits';
    let isAdding = false;
    let selectedCard;
    const selectionParams = new URLSearchParams(window.location.search);
    const requestedVariantId = selectionParams.get('storage') === 'glass'
      ? selectionParams.get('glass_variant')
      : root.dataset.requestedVariantId;
    const requestedCard = requestedVariantId
      ? root.querySelector('.hydro-card[data-variant-id="' + CSS.escape(requestedVariantId) + '"]')
      : null;
    const initialCard = (requestedCard && !requestedCard.disabled ? requestedCard : null) ||
      (selectionParams.get('storage') === 'glass' ? root.querySelector('.hydro-view[data-view="glass"] .hydro-card:not(:disabled)') : null) ||
      root.querySelector('.hydro-view[data-view="kits"] .hydro-card[data-default="true"]:not(:disabled)') ||
      root.querySelector('.hydro-view[data-view="kits"] .hydro-card:not(:disabled)') ||
      root.querySelector('.hydro-card:not(:disabled)');

    if (nativeVariantPicker?.tagName?.toLowerCase() === 'variant-picker') {
      nativeVariantPicker.style.display = 'none';
      nativeVariantPicker.setAttribute('aria-hidden', 'true');
    }

    const syncNativeVariant = (card) => {
      // Glass kits belong to another product. Never write those IDs into the pump form.
      if (card.dataset.productId && card.dataset.productId !== root.dataset.productId) return;
      const variantTitle = card.dataset.variantTitle;
      const variantId = card.dataset.variantId;
      const radio = productInfo.querySelector('input[type="radio"][value="' + CSS.escape(variantTitle) + '"]');
      const hiddenInputs = productInfo.querySelectorAll('input[name="id"]');

      if (radio && !radio.checked) radio.click();

      hiddenInputs.forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    const updateCtas = (card) => {
      const title = card.dataset.title;
      const price = card.dataset.price;
      const subtitle = card.dataset.subtitle;

      if (add) add.textContent = root.dataset.addLabel + ' ' + title + ' · ' + price;
      if (mobileTitle) mobileTitle.textContent = title;
      if (mobileMeta) mobileMeta.textContent = price + ' · ' + subtitle;

      if (note) {
        note.textContent = currentMode === 'kits' ? root.dataset.kitNote : root.dataset.glassNote;
        note.classList.remove('is-error');
      }
    };

    const updateGlassPresentation = (card) => {
      const showingGlass = currentMode === 'glass';
      const showImage = showingGlass && Boolean(card?.dataset.imageUrl);
      if (glassGallery && galleryContainer) {
        galleryContainer.classList.toggle('hydro-show-glass', showImage);
        glassGallery.hidden = !showImage;
        if (showImage && glassImage) {
          glassImage.src = card.dataset.imageUrl;
          glassImage.alt = card.dataset.imageAlt || card.dataset.title;
          galleryContainer.querySelectorAll('video').forEach((video) => video.pause());
        }
      }

      // Keep the pump's variant parameter intact; preserve the selected glass kit separately.
      const url = new URL(window.location.href);
      if (showingGlass && card) {
        url.searchParams.set('storage', 'glass');
        url.searchParams.set('glass_variant', card.dataset.variantId);
      } else {
        url.searchParams.delete('storage');
        url.searchParams.delete('glass_variant');
      }
      window.history.replaceState(window.history.state, '', url.toString());
    };

    const setPurchaseAvailability = (available) => {
      [add, buyNow, mobileButton].forEach((button) => {
        if (button) button.disabled = !available;
      });
      if (!available) {
        if (add) add.textContent = root.dataset.soldOutLabel;
        if (mobileTitle) mobileTitle.textContent = root.dataset.soldOutLabel;
        if (mobileMeta) mobileMeta.textContent = '';
      }
    };

    const selectCard = (card) => {
      if (!card || card.disabled) return;
      const view = card.closest('.hydro-view');

      view.querySelectorAll('.hydro-card').forEach((item) => {
        const active = item === card;
        item.classList.toggle('active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      selectedCard = card;
      setPurchaseAvailability(true);
      syncNativeVariant(card);
      updateCtas(card);
      updateGlassPresentation(card);
    };

    const setMode = (mode, preferredCard) => {
      currentMode = mode;
      root.dataset.activeMode = mode;

      modes.forEach((button) => {
        const active = button.dataset.mode === mode;
        button.classList.toggle('active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
      });

      views.forEach((view) => {
        const active = view.dataset.view === mode;
        view.hidden = !active;
        view.classList.toggle('active', active);
      });

      const view = root.querySelector('.hydro-view[data-view="' + mode + '"]');
      const nextCard = preferredCard || view?.querySelector('.hydro-card.active:not(:disabled)') || view?.querySelector('.hydro-card:not(:disabled)');
      if (nextCard) {
        selectCard(nextCard);
      } else {
        selectedCard = null;
        setPurchaseAvailability(false);
        updateGlassPresentation(null);
      }
    };

    modes.forEach((button, index) => {
      button.addEventListener('click', () => {
        if (!isAdding) setMode(button.dataset.mode);
      });
      button.addEventListener('keydown', (event) => {
        if (isAdding || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? modes.length - 1 :
          (index + (event.key === 'ArrowRight' ? 1 : -1) + modes.length) % modes.length;
        setMode(modes[nextIndex].dataset.mode);
        modes[nextIndex].focus();
      });
    });

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        if (!isAdding) selectCard(card);
      });
    });

    const updateCartDrawerFromSections = (parsedState, sourceButton) => {
      const cartDrawer = document.querySelector('cart-drawer');
      const sectionId = cartDrawer?.getAttribute('data-section-id');
      const sectionHtml = sectionId ? parsedState.sections?.[sectionId] : null;
      if (!cartDrawer || !sectionHtml) return false;

      const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const currentMiniCart = document.getElementById('MiniCart-' + sectionId);
      const updatedMiniCart = parsedHtml.getElementById('MiniCart-' + sectionId);
      if (!currentMiniCart || !updatedMiniCart) return false;

      currentMiniCart.innerHTML = updatedMiniCart.innerHTML;

      const updatedCount = parsedHtml.querySelector('cart-count');
      if (updatedCount) {
        const itemCount = Number.parseInt(updatedCount.textContent, 10) || 0;
        document.querySelectorAll('cart-count').forEach((count) => {
          count.textContent = updatedCount.textContent;
          count.hidden = itemCount === 0;
          if (updatedCount.hasAttribute('aria-label')) {
            count.setAttribute('aria-label', updatedCount.getAttribute('aria-label'));
          }
        });
      }

      if (!cartDrawer.open) cartDrawer.show(sourceButton);
      return true;
    };

    const refreshCartDrawer = () => {
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { open: true }
      }));
    };

    const addSelectedVariantToDrawer = async (sourceButton) => {
      if (!selectedCard || isAdding) return;

      isAdding = true;
      syncNativeVariant(selectedCard);

      const originalText = sourceButton?.textContent;
      if (sourceButton) {
        sourceButton.disabled = true;
        sourceButton.setAttribute('aria-busy', 'true');
        sourceButton.textContent = root.dataset.addingLabel;
      }

      const resetAddingState = () => {
        isAdding = false;
        if (sourceButton) {
          sourceButton.disabled = false;
          sourceButton.removeAttribute('aria-busy');
          sourceButton.textContent = originalText;
        }
      };

      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
        bubbles: true,
        detail: { sections }
      }));

      const formData = new FormData();
      formData.append('id', selectedCard.dataset.variantId);
      formData.append('quantity', '1');
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);

      let parsedState;
      try {
        const themeApi = window.theme || {};
        const response = await fetch(root.dataset.cartAddUrl || themeApi.routes?.cart_add_url || '/cart/add', {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        parsedState = await response.json();
        const errorMessage = parsedState.description || parsedState.message || root.dataset.errorMessage;

        if (!response.ok || parsedState.status) {
          if (note) {
            note.textContent = errorMessage;
            note.classList.add('is-error');
          }
          resetAddingState();
          return;
        }
      } catch (error) {
        console.log(error);
        if (note) {
          note.textContent = root.dataset.errorMessage;
          note.classList.add('is-error');
        }
        resetAddingState();
        return;
      }

      if (note) {
        note.textContent = currentMode === 'kits' ? root.dataset.kitNote : root.dataset.glassNote;
        note.classList.remove('is-error');
      }

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: parsedState }
      }));

      try {
        if (!updateCartDrawerFromSections(parsedState, sourceButton)) refreshCartDrawer();
      } catch (drawerError) {
        console.log(drawerError);
        refreshCartDrawer();
      } finally {
        resetAddingState();
      }
    };

    const triggerBuyNow = () => {
      if (!selectedCard || isAdding) return;
      syncNativeVariant(selectedCard);

      const isLocalPreview = ['127.0.0.1', 'localhost'].includes(window.location.hostname);
      const returnTo = isLocalPreview ? '/cart' : (root.dataset.checkoutUrl || '/checkout');
      const form = document.createElement('form');
      form.method = 'post';
      form.action = root.dataset.cartAddUrl || '/cart/add';
      form.style.display = 'none';

      [
        ['id', selectedCard.dataset.variantId],
        ['quantity', '1'],
        ['return_to', returnTo]
      ].forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    };

    if (add) add.addEventListener('click', () => addSelectedVariantToDrawer(add));
    if (buyNow) buyNow.addEventListener('click', triggerBuyNow);
    if (mobileButton) mobileButton.addEventListener('click', () => addSelectedVariantToDrawer(mobileButton));

    const updateMobileBar = () => {
      if (!mobileBar) return;
      mobileBar.hidden = false;
      const selectorPassed = root.getBoundingClientRect().bottom < 120;
      const visible = window.innerWidth < 768 && selectorPassed;
      mobileBar.classList.toggle('is-visible', visible);
      mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    window.addEventListener('scroll', updateMobileBar, { passive: true });
    window.addEventListener('resize', updateMobileBar);

    const initialMode = initialCard?.closest('.hydro-view')?.dataset.view || 'kits';
    setMode(initialMode, initialCard);
    updateMobileBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHydroSealKitSelector);
  } else {
    initHydroSealKitSelector();
  }

  document.addEventListener('shopify:section:load', initHydroSealKitSelector);
  document.addEventListener('shopify:section:select', initHydroSealKitSelector);
})();
